import useLibrary from "./use-library";
import useUser from "./use-user";

export default function useMyLibrary() {
    const {libraryCode} = useUser();
    const {library, isLoading} = useLibrary(libraryCode || '');

    return {
        isLoading,
        library
    }
}
